export default function(obj) {
	let isNotDefined = true;

	if (
		obj !== undefined &&
		obj !== null &&
		Object.keys(obj).length > 0 &&
		obj.constructor === Object
	) {
		isNotDefined = false;
	}

	return isNotDefined;
}
